import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeMultiIdiomas from '../views/HomeMultiIdiomas.vue'
import Altas from '../views/Altas.vue'
import VueCookie from 'vue-cookie'
import Comprobar from '../views/Comprobar.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:lang',
    component: HomeMultiIdiomas,
    beforeEnter(to, from, next) {
      const lang = to.params.lang
      const idiomas = ['eu', 'es']
      const idioma = idiomas.includes(lang)
      // cl*('rutas', to.params, idioma)
      if (idioma) {

        VueCookie.set('lang', lang)
        next()

      }

    },
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: 'comprobar',
        name: 'Comprobar',
        component: Comprobar
        // component: () => import('../views/Home.vue')
      },
      // {
      //   path: 'about',
      //   name: 'About',
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      // },
      // {
      //   path: 'formulario',
      //   name: 'Formulario',
      //   component: () => import('../views/Formulario.vue')
      // },
      {
        path: 'mapa',
        name: 'Mapa',
        component: () => import('../components/Mapa.vue')
      },
      {
        path: 'bono/:idBono',
        name: 'Bono',
        props: true,
        component: () => import('../views/Ver.vue')
      },
      {
        path: 'altas',
        name: 'Altas',
        component: Altas
        // component: () => import('../views/Home.vue')
      },
      {
        path: 'establecimientos',
        name: 'Buscador',
        component: () => import('../views/Buscador.vue')
        // component: () => import('../views/Home.vue')
      },
      {
        path: 'manual',
        name: 'Manual',
        component: () => import('../views/Manual.vue')
        // component: () => import('../views/Home.vue')
      },
      {
        path: 'berriz-lehiatila',
        name: 'Taquilla',
        component: () => import('../views/Taquilla.vue')
        // component: () => import('../views/Home.vue')
      },
      {
        path: 'detalle',
        name: 'Detalle',
        // props: true,
        component: () => import(/* webpackChunkName: "about" */ '../views/Detalle.vue')
      },
      {
        path: 'comprar',
        name: 'Comprar',
        component: () => import('../views/Comprar.vue')
      },
      {
        path: 'testo',
        name: 'testo',
        // props: true,
        component: () => import(/* webpackChunkName: "about" */ '../components/TestoSearch.vue')
      },
      {
        path: 'detalle-taquilla',
        name: 'Detalletaquilla',
        // props: true,
        component: () => import(/* webpackChunkName: "about" */ '../views/DetalleTaquilla.vue')
      },
      {
        path: 'final',
        name: 'Final',
        component: () => import('../views/PantallaFinal.vue')

      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('../views/Admin.vue')

      },
      {
        path: 'contenido/:idContenido',
        name: 'Contenido',
        props: true,
        component: () => import('../views/Contenido.vue')
      }
    ]
  },
  {
    // Redirect user to supported lang version.
    path: '*',
    redirect(to) {
      // cl*('router', to)
      return 'es'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
